import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { UserService } from './services/user.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { StoreService } from './services/store.service';
import { NavService } from './services/nav.service';
import { CommonService } from './services/common.service';
import { Ui } from './services/ui.service';
import { registerLocaleData } from '@angular/common';
import { ComponentsModule } from './modules/components/components.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { OHttpLoaderService } from './services/o-http-loader.service';
import { FormsModule } from '@angular/forms';
import { UserIdleModule } from 'angular-user-idle';
import { RouteReuseStrategy } from '@angular/router';
import { environment } from 'src/environments/environment';

registerLocaleData(localeFr, 'fr');


registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEn, 'en');

export function HttpLoaderFactory(http: HttpClient) {
  return new OHttpLoaderService(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            backButtonIcon: 'chevron-back'
        }),
        AppRoutingModule,
        ComponentsModule,
        HttpClientModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
              deps: [HttpClient],
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory
            }
          }),
          UserIdleModule.forRoot({idle: environment.idle.value, timeout: environment.idle.timeout , ping: environment.idle.ping})
    ],

    providers: [
        UserService,
        CommonService,
        Ui,

        NavService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },

    ],
    bootstrap: [AppComponent]
})
export class AppModule {}


